import React from 'react'
import { Button, MobileStepper } from '@mui/material'
import NavButtons from './nav-buttons'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(3, 5)
  }
}))

const Stepper = ({
  maxSteps,
  activeStep,
  onLeave,
  onNext,
  onBack,
  onFinish,
  'data-test': dataTest = 'lpq-stepper'
}) => {
  const classes = useStyles()
  return (
    <MobileStepper
      activeStep={activeStep}
      variant='dots'
      steps={maxSteps}
      position='static'
      backButton={
        <Button
          variant='outlined'
          onClick={() => onLeave('do-it-later-button')}
          data-test={`${dataTest}-later-button`}
        >
          Do it later
        </Button>
      }
      nextButton={
        <NavButtons
          activeStep={activeStep}
          maxSteps={maxSteps}
          onBack={onBack}
          onNext={onNext}
          onFinish={onFinish}
          data-test={`${dataTest}-nav`}
        />
      }
      className={classes.root}
      data-test={dataTest}
    />
  )
}

export default Stepper
